var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loading-alpha flex-column",class:{
      active: _vm.$isLoadingAlpha
    }},[_c('b-spinner',{staticClass:"spinner-main",attrs:{"label":"Loading..."}}),_c('img',{staticClass:"mt-2",attrs:{"width":"200","src":require("./assets/images/mascotLoading.png")}}),_c('p',{staticClass:"f-orange mt-2"},[_vm._v("กรุณารอสักครู่ ...")])],1),_c('div',{staticClass:"installment-bg",class:{
      'px-3':
        !_vm.$route.path.includes('register') &&
        !_vm.$route.path.includes('installment') &&
        !_vm.$route.path.includes('setting')
    }},[_c('router-view',{on:{"event-from-installment":_vm.handleFamilyClub}})],1),(_vm.$route.path.includes('installment'))?_c('NavFooter',{ref:"navFooter",staticClass:"h-100",attrs:{"lineId":_vm.lineId,"id":"navFooter"}}):_vm._e(),_c('TryagainModel'),_c('SuccesModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }